import { fieldTypes, guessType, registerType } from "./fieldTypes.js";

export { fieldTypes, guessType, registerType };
export { getFields } from "./getFields.js";
export { handleResponseError } from "./handleResponseError.js";
export { isEqual } from "./isEqual.js";
export { requestTimeout } from "./requestTimeout.js";

export const indexError = (idx: number) => `No record found with index ${idx}`;
